// Copied over from the jira-update-work-item-fields-action-renderer package
import React from 'react';

import { cssMap } from '@atlaskit/css';
import CheckMarkIcon from '@atlaskit/icon/core/check-mark';
import CrossIcon from '@atlaskit/icon/core/cross';
import { Flex, Inline, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

type Props = {
	message: string;
	isSuccessMessage?: boolean;
};

const styles = cssMap({
	explainerContainer: {
		paddingTop: token('space.150'),
		paddingBottom: token('space.150'),
		paddingLeft: token('space.150'),
		paddingRight: token('space.150'),
		gap: token('space.150'),
	},
	explainer: {
		paddingTop: token('space.050'),
		paddingBottom: token('space.050'),
		paddingLeft: token('space.100'),
		paddingRight: token('space.100'),
		gap: token('space.075'),
		borderRadius: token('radius.full'),
		border: `${token('border.width')} solid ${token('color.border')}`,
	},
});

export const SystemMessage = ({ message, isSuccessMessage = true }: Props): React.JSX.Element => {
	return (
		<Flex
			xcss={styles.explainerContainer}
			alignItems="center"
			justifyContent="center"
			direction="column"
		>
			<Inline xcss={styles.explainer} alignBlock="center" alignInline="center">
				{isSuccessMessage ? (
					<CheckMarkIcon label="" color={token('color.icon.success')} />
				) : (
					<CrossIcon label="" color={token('color.icon.danger')} />
				)}
				<Text maxLines={1}>{message}</Text>
			</Inline>
		</Flex>
	);
};
